import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import MessageApp from "./MessageApp"

const MessageAppManagement = () => {
  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar: fixed */}
      <div className="h-screen bg-gray-100 flex-shrink-0">
        <Sidebar />
      </div>

      {/* Main content: scrollable */}
      <div className="flex-1 overflow-y-auto bg-gray-50">
        <div className="p-4">
          {/* Define routes here */}
          <Routes>
            <Route path="/ChatApp" element={<MessageApp />} />
            {/* Add more routes if needed */}
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default MessageAppManagement;
